import moment from 'moment';
import _ from 'underscore';
import Util from '../util';
import Q from 'q';

export const MYSQL_FORMAT = 'YYYY-MM-DD HH:mm:ss';

export default [
	{
		title: 'Upcoming',
		arguments: function (list, currentRaces) {
			return {
				parameters: {
					'field_date.ge': moment().add(1, 'day').startOf('day').format(MYSQL_FORMAT) // All races after today.
				},
				sort: 'field_date',
				direction: 'asc',
				pagesize: 100
			};
		},
		cache: 'upcoming-races',
		showUpcoming: true,
		maxIterations: 1,
		filters (list) {
			return [function (races) {
				var lastDate = false;
				var iterations = 1;
				return _.filter(races, function (race) {

					if (lastDate === false) {
						lastDate = race.date;
						return true;
					}

					if (!Util.sameDay(lastDate, race.date) && iterations < list.maxIterations) {
						lastDate = race.date;
						iterations++;
						return true;
					}

					return Util.sameDay(lastDate, race.date);

				});
			}];
		},
		fail (list) {
			list.showUpcoming = false;
		}
	},
	{
		title: 'Today',
		class: 'emphasis',
		id: 'race-schedule-today',
		arguments: function () {
			return {
				parameters: {
					field_date: moment().startOf('day').format(MYSQL_FORMAT)
				}
			};
		}
	},
	{
		title: 'Yesterday',
		arguments: function () {
			return {
				parameters: {
					field_date: moment().startOf('day').subtract(1, 'day').format(MYSQL_FORMAT)
				}
			};
		}
	}
];



/** WEBPACK FOOTER **
 ** ./site/sites/all/themes/custom/abr_theme/js/race-schedule/mock/RaceLists.js
 **/